import styled from 'styled-components';

// Medidas do protótipo: card de progresso, grupos por momento com ícone e contador.
export const Container = styled.div`
  .progress-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
  }

  .progress-head {
    display: flex;
    justify-content: space-between;
    color: #21354a;

    strong {
      font-weight: 600;
    }
  }

  .progress-bar-track {
    height: 6px;
    border-radius: 3px;
    background: #e9ecef;
    overflow: hidden;
    margin: 10px 0;

    span {
      height: 100%;
      display: block;
      background: #28a745;
      transition: width 0.3s;
    }
  }

  .progress-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
    font-size: 13px;

    > span {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .material-icons-outlined {
      font-size: 17px;
    }
  }

  .text-warning-dark {
    color: #856404;
  }

  .moment-group {
    margin-top: 24px;

    > header {
      margin-bottom: 10px;
    }

    h2 {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 18px;
      font-weight: 500;
      color: #21354a;
      margin: 0;

      .material-icons-outlined {
        color: #6c757d;
      }
    }

    small {
      font-size: 13px;
      color: #6c757d;
    }

    .count {
      font-size: 12px;
      color: #6c757d;
      background: #f8f9fa;
      padding: 2px 7px;
      border-radius: 4px;
      font-weight: 500;
    }
  }

  .checks {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;
